import script from "./editModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./editModal.vue?vue&type=script&setup=true&lang=ts"

import "./editModal.vue?vue&type=style&index=0&id=33490622&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33490622"]])

export default __exports__